import BaseService from "./geral/BaseService";
import { urlApi } from "../config/Constantes";
import { objetoParaQueryString } from "../utils/formatar";

const base = "AlteraDtaDtc";

export default class NotaFiscalFaturamentoService extends BaseService {
    constructor() {
        super(base);
    }

    obterCliente(cnpj) {
        const params = cnpj ? `?cnpj=${cnpj}` : ''
        return super.httpGet(`/${base}/ObterCliente${params}`);
    }

    salvar(codigoCobrarDe, documento){
        return super.httpPost(`/${base}/Salvar`, { codigoCobrarDe, documento });
    }

}


// WEBPACK FOOTER //
// ./src/services/AlteraDtaDtcService.js